import { Card, Col, Row, Tag } from "rsuite";
import type { FlightDepartureComponentProps } from "../my-type";
import { AirplaneFill } from "react-bootstrap-icons";
import { useGetAirlines } from "../hooks/Airline";
import { useEffect, useState } from "react";


export default function FlightDepartureComponent({ flightDeparture }: FlightDepartureComponentProps) {
  const { airlines } = useGetAirlines();
  const [airlineName, setAirlineName] = useState<string | undefined>(undefined);

  useEffect(() => {
    let airline = airlines.find(element => element.airlineID === flightDeparture.airlineID);
    if (airline) {
      if (airline.airlineName.zh_tw) {
        setAirlineName(airline.airlineName.zh_tw);
      } else {
        setAirlineName(airline.airlineName.en);
      }
    }


  }, [])

  return (<div style={{ paddingLeft: '10px', paddingRight: '10px', width: '100%' }}>
    <Card size="sm">
      <Card.Body>
        <Row>
          <Col xs={2}><AirplaneFill /></Col>
          <Col xs={16} style={{ textAlign: 'left' }}>{airlineName}<br></br>{flightDeparture.airlineID}{flightDeparture.flightNumber}</Col>
          <Col xs={6} style={{ textAlign: 'right' }}>航廈T{flightDeparture.terminal}<br></br>登機門{flightDeparture.gate}</Col>
        </Row>
        <Row>
          <Col xs={2}></Col>
          <Col xs={16} style={{ textAlign: 'left' }}>
            預定:{flightDeparture.scheduleDepartureTime.split('T')[1]}&nbsp;
            預估:{flightDeparture.estimatedDepartureTime.split('T')[1]}<br></br>
            {flightDeparture.arrivalAirportID}</Col>
          <Col xs={6} style={{ textAlign: 'right' }}><br></br><Tag>{flightDeparture.departureRemark}</Tag></Col>
        </Row>
      </Card.Body>
    </Card>
  </div>)
}
